import { serverAiBuilderChatAdapter } from './serverAiBuilderChatAdapter';
import { type AiBuilderChatAdapter } from './types';

export const aiBuilderChatAdapter: AiBuilderChatAdapter =
  serverAiBuilderChatAdapter;
